export default __webpack_public_path__ + "static/media/clearProgram _inA.bbefc6a6.png";